import { render, staticRenderFns } from "./ProgramFaqTab.vue?vue&type=template&id=38a738fc&"
import script from "./ProgramFaqTab.vue?vue&type=script&lang=js&"
export * from "./ProgramFaqTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports